import {
  supportChatModalDe,
  supportChatModalEn,
  supportChatModalEs,
  supportChatModalIt,
  supportChatModalNl,
  supportChatModalPtBr,
  supportChatModalTr,
  supportChatModalZhHans,
} from "@src/i18n/translations/modules/support-chat-modal.i18n";

const handoverMessages = [
  supportChatModalEn.supportChatModal.handoverText,
  supportChatModalPtBr.supportChatModal.handoverText,
  supportChatModalDe.supportChatModal.handoverText,
  supportChatModalZhHans.supportChatModal.handoverText,
  supportChatModalIt.supportChatModal.handoverText,
  supportChatModalEs.supportChatModal.handoverText,
  supportChatModalNl.supportChatModal.handoverText,
  supportChatModalTr.supportChatModal.handoverText,
];

const normalizeMessageText = (value: string) =>
  value
    .replace(/<br\b[^>]*>/gi, " ")
    .replace(
      /<\/?(?:address|article|aside|blockquote|dd|details|dialog|div|dl|dt|fieldset|figcaption|figure|footer|form|h[1-6]|header|hr|li|main|nav|ol|p|pre|section|table|tbody|td|tfoot|th|thead|tr|ul)\b[^>]*>/gi,
      " ",
    )
    .replace(/<[^>]*>/g, "")
    .replace(/\s+/g, " ")
    .trim();

export const isSupportHandoverMessage = (content: string): boolean => {
  const normalizedContent = normalizeMessageText(content);
  return handoverMessages.some(
    (message) => normalizedContent === normalizeMessageText(message),
  );
};
